// cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import { platform } from 'os';
const cn = {
  button: {
    save: '保存',
    mapping: '映射',
    cancel: '取消',
    reset: '重置',
    submit: '提交',
    search: '搜索',
    search2: '查询',
    add: '添加',
    change: '修改',
    delete: '删除',
    edit: '编辑',
    confirm: '确定',
    upload: '上传',
    last_step: '上一步',
    next_step: '下一步',
    pick_upo: '收起',
    spread: '展开',
    delete_continue: '继续删除',
    batch_tool: '批量工具',
    close: '关闭',
    yes: '是',
    no: '否',
    not_tie: '不再提示' // titleInfo.vue
  },
  page: {
    show_list: '展开列表',
    hide_list: '收起列表',
    choose_languages: '请选择语言',
    chinese_languages: '中文',
    english_languages: 'English',
    please_enter_tracking_limit: '请输入运单号，最多不能超过40条',
    delete_all: '删除全部',
    select_no: '筛选单号',
    delete_carrier: '清除运输商',
    carrier: '运输商',
    track: '查询',
    one_line_enter_limit: '每行输入一个单号，最多允许提交40个单号',
    more_than_limit_number_tip: '注意：最多允许提交40个单号！',
    please_enter_tracking_no: '请输入单号',
    more_than_limit_number_tip2: '查询订单超出限制，最多只能查询40条',
    some_tracking_no_wrong: '填写的运单号中有误',
    quick_track: '快速查询',
    choose_carrier: '选择运输商',
    not_find_carrier: '查找不到运输商',
    common_carrier: '常用运输商',
    global_postal_service: '全球邮政',
    international_carrier: '国际运输商',
    chinese_carrier: '中国运输商',
    return: '返回',
    has_found_carrier: '自动识别运输商',
    please_input_carrier: '请输入运输商',
    global_logistics_tracking_platform: '全球物流查询平台',
    tracking_more: '查询更多',
    not_find_data: '暂无快速查询数据',
    tracking_no: '运单号',
    please_track__latter: '请稍后再尝试查询',
    being_in_query: '运单轨迹正在查询中',
    failed_query: '运单轨迹查询失败，可稍后重新查询或重新选择运输商',
    cannot_found_carrier_please_choose_carrier: '匹配不到运输商，请选择运输商',
    maybe_these_carrier: '运单可能为以下的运输商，请选择',
    not_find_tracking: '暂无查询到轨迹',
    newest_data_tracked: '上次追踪到最新轨迹的时间',
    check_failure: '查询失败原因',
    not_found_temporaily: '暂无该段轨迹',
    copy_tracking_content: '复制内容',
    copy_tracking_url: '复制链接',
    success_copy_tracking_content:　'复制内容成功',
    success_copy_tracking_url: '复制链接成功',
    All: '全部',
    Pending: '等待查询',
    Not_Found: '查询不到',
    Info_Received: '预报发货',
    In_Transit: '运输途中',
    Pick_Up: '到达待取',
    Delivering: '派送途中',
    Undelivered: '投递失败',
    Delivered: '成功派送',
    Return: '包裹退回',
    Exception: '包裹异常',
    welcome_to_tracking_yee: '欢迎使用物流轨迹跟踪系统',
    in_query: '查询中',
    query_failed: '查询失败',
    query_successful: '查询成功',
    not_supported_query: '暂不支持该运输商查询',
    not_provide_logistics: '该运输商暂不提供物流轨迹',
    please_choose_carrier: '请选择运输商',
    please_no_get_track: '请输入运单号，然后获取跟踪结果',
    login: '登录',
    signup: '注册',
    Cross_border:'合作运输商',
    each_package: '轻松追踪每件包裹的实时动态',
    worldwide: '支持查询全球超过300家快递公司',
    see_more:'查看更多',
    monitoring_management:'为卖家量身定制的物流监控管理系统，轻松追踪每件包裹的实时动态',
    Click_fast:'快点击',
    or:'或',
    Accounts:'账号',
    Use_it_now:'马上使用体验吧！',
    Copyright:'版权所有 ICP证：',
    about_Tracking_Yee:'关于Tracking Yee',
    home_page:'首页',
    Transporter_list:'运输商列表',
    Help_sellers:'帮助卖家选择更适合自己的运输渠道',
    Support_query:'支持查询',
    dont_Support_query:'不支持查询',
    all:'全部',
    Please_enter:'请输入内容',
    search: '搜索',
    vesaas:'Tracking Yee',
    The_operation:'操作简单，数据状态一目了然，省时又省心！',
    for_free:'想要免费获取这么详细的报表，',
    Highlight:'亮点功能介绍',
    Track_logistics:'实时追踪物流状态，轻松管理订单物流信息，自动生成报表协助分析物流时效',
    major:'轨迹追踪工具的  3  大功能',
    Waybill:'运单轨迹查询',
    When_you_query_once:'您一次查询，系统即可N次定时跟踪，直至包裹妥投才算完成轨迹追踪；',
    Support_to_set_platform:'支持设置平台运单时效规则',
    Supports_rule_setting:'您做好各个平台的时效监控设置，例如某个平台上传了运单号的包裹，需要在7天内上网。那么，系统自动监控您查询的运单，如果有运单派送超过7天才有上网轨迹，您即可在进入工作台后就可以看到系统预警的该异常运单信息；',
    Support_setting:'支持设置物流服务商承诺时效规则',
    delivery_efficiency:'您如果想监控您的物流服务商对您承诺的物流时效是否达标，您即可设置好物流服务商下具体物流服务的时效（可具体到物流服务对应不同的运输商情况）。系统即可根据您设置的物流时效规则，自动监控查询的运单的物流时效结果，统计达成承诺的时效对比，为您后续优化物流服务决策做实力参照。',
    Meamwhile:'同时，针对运单轨迹查询功能，',
    have_multiple:'为方便大家在各类场景进行查询，也设置了多样化查询方式：',
    You_can_inquiry:'直接在输入框内输入运单号查询，一般单次查询数量不超过40条;',
    Import_query:'导入查询',
    Import_order_number:'当您单量大的时候，您用EXCEL表，批量导入即可大批量查询。支持仅导入运单号进行查询哦；',
    Store_authorization:'店铺授权',
    make_a_store_authorization:'您做了店铺授权，不再需要每天去人工导入。可以系统自动定时抓取授权对象待查询运单（目前是销售平台店铺，后续会增加第三方物流服务商，ERP等平台对接），只需要定时查询下载监控数据结果即可。',

    // functionalAdvantages
    functionalAdvantages_oneStopStr:'TrackingYee，一站式订单查询及监控，物流报表管理系统。可支持用户跟踪订单物流轨迹，根据用户所需要的规则监控运单时效，支持对比物流服务商承诺时效。物流数据一目了然，筛选优质供应商；有效响应并处理异常运单，解决您80%的售后问题，让您的生意更健康。智能化监控运单，多维度时效分析，您值得信赖的物流管家！',//TrackingYee,One-stop order inquiry and monitoring, logistics report management system. It can support users to track the logistics track of orders, monitor the timeliness of waybills according to the rules required by users, and support comparing the timeliness promised by logistics service providers. Logistics data at a glance, select quality suppliers; Respond to and handle abnormal waybills effectively, solve 80% of your after-sales problems, and make your business healthier. Intelligent monitoring waybill, multi-dimensional timeliness analysis, your trustworthy logistics butler!
    functionalAdvantages_track:'包裹运单轨迹跟踪',//Track the track of the parcel waybill
    functionalAdvantages_once:'1次查询，系统即可自动录入并定时追踪更新状态',//Once the query, the system can automatically enter and regularly track the update status
    functionalAdvantages_various:'多种运单导入方式：操作简单，数据状态一目了然',//Various ways of waybill import: simple operation, clear data status
    functionalAdvantages_toQuery:'我要查询',//To Query
    functionalAdvantages_intelligent:'智能时效监控预警',//Intelligent aging monitoring and warning
    functionalAdvantages_supportPlatform:'支持自定义设置不同平台物流考核时效规则并进行监控',//Support the custom setting of different platform logistics evaluation prescription rules and monitoring
    functionalAdvantages_supportCommitment:'支持自定义物流商承诺时效考核',//Support custom logistics commitment time assessment
    functionalAdvantages_orderWarning:'订单异常状态预警',//Order abnormal status warning
    functionalAdvantages_immediately:'马上使用',//Use immediately
    functionalAdvantages_systemAccording:'系统可按不同平台、店铺、物流商、国家、地区等分布形成报表',//The system can form reports according to the distribution of different platforms, stores, logistics providers, countries and regions
    functionalAdvantages_distribution:'展示不同发货日期包裹运单派送状态分布图',//Display distribution charts of parcel waybills on different delivery dates
    functionalAdvantages_presentation:'多维度报表数据展示',//Multi-dimensional report data presentation

    functionalAdvantages_morePersonalized:'更多个性化功能在等你，解决您 80% 的售后问题，让您的生意更健康。',//More personalized features are waiting for you to solve 80% of your after-sales problems and make your business healthier.
    functionalAdvantages_experience:'您还在犹豫什么，立即开启您的全新体验吧！',//What are you hesitating about? Start your new experience now!
    functionalAdvantages_tryNow:'立即试用',//Try Now
    functionalAdvantages_waybillQuery:'运单查询',//Waybill Query
    functionalAdvantages_waybillQuery1:'运单查询',
    functionalAdvantages_functionalAdvantages:'功能优势',//Functional Advantages
    functionalAdvantages_externalCall:'外部调用',//Functional externalCall
    // home
    home_a:'智能化监控运单，多维度时效分析',//Intelligent monitoring waybill, multi-dimensional aging analysis
    home_aaaa:'',
    home_b:'您值得信赖的物流管家！',//Your trustworthy logistics butler!
    home_c:'请输入运单号，然后获取跟踪结果',//Please enter the tracking number and get the tracking results
    home_d:'请输入运单号，以逗号分隔',//Please enter the tracking number separated by commas
    home_e:'运输商',//Carrier
    home_f:'TrackingYee，一站式订单查询及监控，物流报表管理系统。可支持用户跟踪订单物流轨迹，根据用户所需要的规则监控运单时效，支持对比物流服务商承诺时效。物流数据一目了然，筛选优质供应商；有效响应并处理异常运单，解决您',//TrackingYee, one-stop order query and monitoring, logistics report management system. It can support users to track the logistics track of orders, monitor the timeliness of waybills according to the rules required by users, and support comparing the timeliness promised by logistics service providers. Logistics data at a glance, select quality suppliers; Respond effectively and handle abnormal waybills,Solve
    home_g:'80%的售后问题，让您的生意更健康。智能化监控运单，多维度时效分析，您值得信赖的物流管家！',//of your after-sale problems,To make your business healthier. Intelligent monitoring waybill, multi-dimensional timeliness analysis, your trustworthy logistics butler!
    home_ggg:'',
    home_h:'功能多样全面',//Diverse and comprehensive functions
    home_i:'集海量运单查询，监控及管理报表于一体，全面掌握运单、物流情况，不再被动',//Set the massive waybill query, monitoring and management report in one, the comprehensive grasp of waybill, logistics, no longer passive
    home_j:'自动化管理',//Automated Management
    home_k:'系统简单易懂、功能界面清晰， 快速上手',//The system is easy to understand, the function interface is clear, quick to get started
    home_l:'一对一客服',//One-on-one customer service
    home_m:'随时解答您的疑问，快速响应您的需求，您值得信赖',//Answer your questions at any time, quickly respond to your needs, you are trustworthy
    home_n:'多样化的',//A variety of
    home_o:'功能',//functions
    home_p:'，总有满足您的需求',//, there is always to meet your needs
    home_q:'店铺授权',//Shop authorization
    home_r:'多种订单导入方式查询',//A variety of order import queries
    home_s:'平台、物流多维度报表管理',//Multi-dimensional report management of platform and logistics
    home_t:'物流商时效监控',//Time monitoring of logistics providers
    home_u:'平台时效设置',//Platform aging setting
    home_v:'进入系统',//Enter The System
    home_w:'查看更多',//See More
    home_x:'我们的',//Our
    home_y:'优势',//advantages
    home_z:'，更全面的为您服务',//, more comprehensive service for you
    home_aa:'TrackingYee 适合什么用户？',//TrackingYee For what users?
    home_bb:'电商卖家',//Seller
    home_cc:'运单轨迹监控、运单状态分布、',//Waybill track monitoring, waybill status distribution, abnormal waybill warning, improve
    home_dd:'异常运单预警、提高买家体验、优化物流服务',
    home_dd1:'',
    home_ee:'电商平台',//e-commerce platform
    home_ff:'（1）及时跟踪订单轨迹信息、为平台提供原始数据以供判断纠纷订单责任方',//(1) Timely track order track information and provide original data for the platform
    home_gg:'（2）统计报表分析平台物流表现情况，精准分析单个店铺物流表现',//Judge the party responsible for the order
    home_hh:'',//(2) Statistical report analysis platform logistics performance,
    home_ii:'',//accurate analysis of a single store Shop logistics performance
    home_kk:'收款公司',//Collecting company
    home_ll:'（1）根据妥投信息安排用户回款、把控并降低资金风险',//(1) Arrange payment collection, control and reduce capital risks according to the information of proper investment
    home_mm:'（2）把握商户运营质量',//(2) Grasp the operation quality of merchants
    home_mm1:'',
    home_nn:'货运代理',//Freight Forwarder
    home_oo:'（1）监控各节点信息、提高物流质量、增强用户粘度',//(1) Monitor information of each node, improve logistics quality, and enhance user viscosity
    home_pp:'（2）根据异常订单向供应商申请索赔',//(2) Apply for claims from suppliers according to abnormal orders
    home_pp1:'',
    home_qq:'智能化监控运单，多维度时效分析，您值得信赖的物流管家！',//Intelligent monitoring waybill, multi-dimensional timeliness analysis, your trustworthy logistics butler!
    home_rr:'多维渡为您提供的优秀服务，立即开启您的全新体验吧！',//The excellent service provided by Duowu will open your new experience immediately!
    home_ss:'支持查询全球超过',//Support to query
    home_tt:'350+ 家运输商',//more than 350 carriers worldwide
    home_uu:'高效的运单轨迹追踪',//Efficient waybill tracking
    home_vv:'监控订单的全程物流时效及妥投情况',//Monitor the logistics timeliness and delivery of orders
    home_ww:'订单监控，可及时处理异常订单',//rder monitoring, can deal with abnormal orders in time
    home_xx:'邮件、短信、客户端等多种通知方式，用户可及时查看异常订单并处理',//Email, SMS, client and other notification methods, users can timely view abnormal orders and deal with
    home_yy:'专业的数据分析',//Professional data analysis
    home_zz:'按不同平台、店铺、物流商、国家、地区等信息进行精密计算，展示多维度报表',//Precise calculation according to different platforms, stores, logistics providers, countries, regions and other information, display multi-dimensional reports
    home_aaa:'精准的物流商对接',//Accurate logistics business docking
    home_bbb:'已接入350+家主流物流商并持续增加中',//It has access to more than 250 major logistics providers and continues to increase
    home_ccc:'展开全部',//On All
    home_ddd:'了解',//Know
    home_eee:'收起',//


    // pagefooter
    pagefooter_a:'智能化监控运单，多维度时效分析，您值得信赖的物流管家！留下你的联系方式，让我们马上为您服务吧！',//Intelligent monitoring waybill, multi-dimensional timeliness analysis, your trustworthy logistics butler! Leave your contact information, let us serve you right away!
    pagefooter_b:'联系电话',//Tel
    pagefooter_c:'联系邮箱',//Email
    pagefooter_d:'联系地址： 深圳市南山区世外桃源创意园C栋308-310室',//Address: Room 308-310, Building C, Xanadu Creative Park, Nanshan District, Shenzhen
    pagefooter_e:'分享到微信朋友圈',//Share it on WeChat
    pagefooter_f:'打开微信，点击底部的“发现”，',//Open up WeChat, click on find at the bottom,
    pagefooter_g:'使用“扫一扫”即可将网页分享至朋友圈。',//Use "scan" to share your web page to your moments.
    pagefooter_h:'请输入运输商',//Please enter the carrier
    pagefooter_i:'返回顶部',//Top

    // logisticsList
    logisticsList_a:'支持查询全球超过',//Support to query over
    logisticsList_b:'家运输商',//carriers worldwide
    logisticsList_c:'帮助卖家选择更适合自己的运输渠道',//Help the seller to choose a more suitable transport channel

    components_a:'开始查询',//Query

    trajectoryTracking_head_title:'外部调用',
    trajectoryTracking_head_title1:'通过集成该物流跟踪组件，将其嵌入到你的网站，可以让网站访问者在你的网页上直接查询运单的追踪详情',
    trajectoryTracking_single_model:'单个查询模式',
    trajectoryTracking_singleLink_model:'指定单号查询模式',
    trajectoryTracking_batch_model:'批量查询模式',
    trajectoryTracking_model_introduction:'模式介绍',
    trajectoryTracking_model_introduction_a:'你可以增加一个单行输入框和查询按钮，网站访问者可以输入跟踪号后，点击查询时根据你的配置来展示查询结果。',
    trajectoryTracking_model_introduction_b:'是将支持多个单号的输入框嵌套在你的网站，点击时将直接跳转到TrackingYee来显示查询结果。',
    trajectoryTracking_model_introduction_c:'你也可以在具体按钮，超链接文本，图标等等元素上，按钮上附加点击事件指定单号，使其点击可以展示查询结果。',
    trajectoryTracking_Example_effect:'示例效果',
    trajectoryTracking_number_tips:'请输入运单号，然后获取跟踪结果',
    trajectoryTracking_Example:'示例',
    trajectoryTracking_btn:'开始查询',


    trajectoryTracking_Parameter:'参数制定',
    trajectoryTracking_Parameter_id:'指定承载内容的容器ID',
    trajectoryTracking_Parameter_w:'查询结果宽度',
    trajectoryTracking_Parameter_h:'查询结果宽度',
    trajectoryTracking_Parameter_m:'结果展示模式',
    trajectoryTracking_Parameter_s:'运输商',
    trajectoryTracking_Parameter_n:'查询单号',

    trajectoryTracking_Parameter_dm:'调用代码',
    trajectoryTracking_Parameter_body1:'在您的页面上一次添加以下javascript，最好在开始',
    trajectoryTracking_Parameter_body2:'标记之后。',
    trajectoryTracking_Parameter_copy:'复制代码',
    trajectoryTracking_Parameter_script1:'将下面的代码复制并粘贴到您的页面中',
    trajectoryTracking_Parameter_script2:'标记之间',
    trajectoryTracking_Parameter_script3:'无论您放置什么按钮，这些按钮都会显示',
    trajectoryTracking_notes1:'单号输入框',
    trajectoryTracking_notes2:'用于调用脚本方法的按钮',
    trajectoryTracking_notes3:'用于显示查询结果的容器',
    trajectoryTracking_notes4:'脚本代码可放于页面底部，等到页面最后执行',
    trajectoryTracking_notes5:'必须，指定承载内容的容器ID',
    trajectoryTracking_notes5_:'必须，指定悬浮位置的元素ID',
    trajectoryTracking_notes6:'可选，指定查询结果宽度',
    trajectoryTracking_notes7:'可选，指定查询结果高度',
    trajectoryTracking_notes8:'结果展示模式，默认为扩大嵌套区域显示查询结果',
    trajectoryTracking_notes9:'可选，指定运输商，默认为自动识别',
    trajectoryTracking_notes10:'可选，指定UI语言，默认中文',
    trajectoryTracking_notes11:'用于显示查询输入框的容器',
    trajectoryTracking_notes12:'查询结果将悬浮于此元素',
    trajectoryTracking_notes13:'必须，指定要查询的单号',
    trajectoryTracking_min:'最小为',
    trajectoryTracking_default:'默认为',

    trajectoryTracking_Parameter_IDplaceholder:'请输入承载内容的容器ID',
    trajectoryTracking_Parameter_nesting:'扩大嵌套区域显示查询结果',
    trajectoryTracking_Parameter_suspension:'悬浮框显示查询结果',
    trajectoryTracking_Parameter_sPlaceholder:'可指定运输商，默认自动匹配',
    trajectoryTracking_Parameter_Nplaceholder:'请输入要查询的单号',
  },//
  success: {
    keep: '保存成功',//
    add: '添加成功',//
    delete: '删除成功'
  },
  // 统一错误信息处理
  error: {
    correct_input: '请完成您的输入',
    Time_inclusion: '您当前设置选择时段包含已经设置的待启用规则时段，请先修改待启用规则时段，再修改当前启用规则时段。'
  },
  ...zhLocale
}

export default cn



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js